import { useQuery } from '@tanstack/react-query'
import { metricsApi } from '../services/birdbrain-api-client'

export function useBusinessMetrics() {
  const query = useQuery({
    queryKey: ['metrics', 'business'],
    queryFn: () => metricsApi.getBusinessMetrics(),
    // Preserves the old 15-minute background refresh
    refetchInterval: 15 * 60 * 1000,
  })
  return {
    data: query.data ?? null,
    loading: query.isPending,
    refreshing: query.isFetching && !query.isPending,
    error: query.error,
    refetch: query.refetch,
    updatedAt: query.dataUpdatedAt ? new Date(query.dataUpdatedAt) : null,
  }
}
